<script setup lang="ts">
import AdminMenu from './AdminMenu.vue'
import AdminSmallMenu from './AdminSmallMenu.vue'
import { useModal } from '~/composables/useModal'

/**
 *
 *  Props and emits section
 *
 *
*/

/**
 *
 *  Ref, computed and hooks section
 *
 *
*/

const { modal: drawer, toggleModal: toggleDrawer } = useModal(true)

/**
 *
 *  Life cicle events
 *
 *
*/

/**
 *
 *  Functions section
 *
 *
*/
</script>

<template>
    <aside class="admin-drawer-container tw-relative tw-bg-adminPrimary-500 tw-py-5 tw-flex tw-flex-col tw-items-center tw-gap-4 tw-min-h-screen tw-h-full">
        <div @click="toggleDrawer" class="tw-cursor-pointer tw-absolute tw-right-2 tw-top-5 tw-w-[25px] tw-h-[25px] tw-bg-adminAccent-200 tw-flex tw-items-center tw-justify-center tw-border tw-border-adminAccent-200 tw-rounded-[3px]">
            <q-icon name="chevron_left" class="tw-text-adminAccent-500" size="20px" v-if="drawer" />
            <q-icon name="chevron_right" class="tw-text-adminAccent-500" size="20px" v-else />
        </div>

        <div :class="`${drawer ? '' : 'admin-drawer-menu-hidden'} tw-pt-[20px] admin-menu-container tw-w-full tw-min-w-[100px] lg:tw-min-w-[250px] tw-flex tw-flex-col tw-items-start`">
            <AdminMenu />
        </div>
        <div :class="`${drawer ? 'admin-drawer-menu-hidden' : ''} tw-pt-[40px] admin-small-menu-container tw-w-full tw-min-w-[50px] lg:tw-min-w-[80px] tw-flex tw-flex-col tw-items-center`">
            <AdminSmallMenu />
        </div>
    </aside>
</template>
<style>
.admin-drawer-container {
    scrollbar-width: none;
}

.admin-drawer-container::-webkit-scrollbar {
    display: none;
}

.admin-drawer-menu-hidden{
    @apply !tw-hidden;
}
</style>
